import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Send, MessageCircle, Phone } from 'lucide-react';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Button } from './ui/button';
import { useSettings } from '../context/SettingsContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ContactForm = ({ carId, carInfo }) => {
  const { settings } = useSettings();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: carInfo ? `Olá, estou interessado no ${carInfo}. ` : ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.phone || !formData.message) {
      toast.error('Por favor preencha todos os campos');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/leads`, { ...formData, car_id: carId || null });
      toast.success('Mensagem enviada com sucesso! Entraremos em contacto brevemente.');
      setFormData({ name: '', phone: '', message: '' });
    } catch (error) {
      toast.error('Erro ao enviar mensagem. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleWhatsApp = () => {
    const message = encodeURIComponent(`Olá, chamo-me ${formData.name}. ${formData.message}`);
    const phoneNum = settings.phone_intl.replace('+', '');
    window.open(`https://wa.me/${phoneNum}?text=${message}`, '_blank');
  };

  return (
    <div className="bg-[#090A0F] p-8 border border-zinc-800">
      <h3 className="text-xl font-medium text-white mb-6">Envie-nos uma Mensagem</h3>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="text-zinc-400 text-sm mb-2 block">Nome</label>
          <Input type="text" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            placeholder="O seu nome" className="bg-[#12141D] border-zinc-800 text-white placeholder:text-zinc-600 focus:border-red-500" data-testid="contact-name-input" />
        </div>
        <div>
          <label className="text-zinc-400 text-sm mb-2 block">Telemóvel</label>
          <Input type="tel" value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            placeholder="+351 912 345 678" className="bg-[#12141D] border-zinc-800 text-white placeholder:text-zinc-600 focus:border-red-500" data-testid="contact-phone-input" />
        </div>
        <div>
          <label className="text-zinc-400 text-sm mb-2 block">Mensagem</label>
          <Textarea value={formData.message} onChange={(e) => setFormData({ ...formData, message: e.target.value })}
            placeholder="A sua mensagem..." rows={4} className="bg-[#12141D] border-zinc-800 text-white placeholder:text-zinc-600 focus:border-red-500 resize-none" data-testid="contact-message-input" />
        </div>
        <div className="flex flex-col sm:flex-row gap-3 pt-4">
          <Button type="submit" disabled={loading} className="bg-white text-black font-semibold px-6 py-3 hover:bg-zinc-200 transition-colors flex-1 rounded-none" data-testid="contact-submit-btn">
            <Send size={18} className="mr-2" /> {loading ? 'A enviar...' : 'Enviar Mensagem'}
          </Button>
          <Button type="button" onClick={handleWhatsApp} className="bg-[#25D366] text-black font-semibold px-6 py-3 hover:bg-[#1DA851] transition-colors flex-1 rounded-none" data-testid="contact-whatsapp-btn">
            <MessageCircle size={18} className="mr-2" /> WhatsApp
          </Button>
        </div>
        <a href={`tel:${settings.phone_intl}`} className="flex items-center justify-center gap-2 w-full py-3 bg-red-600 hover:bg-red-700 text-white font-semibold transition-colors mt-3" data-testid="contact-call-btn">
          <Phone size={18} /> Ligue-nos: {settings.phone}
        </a>
      </form>
    </div>
  );
};

export default ContactForm;
